// Deriva o availability do PROPRIO agente do payload de presenca do fork,
// replicando o setCurrentUserAvailability do fork (auth.js:212) — zero HTTP.
// Mata o storm de GET /chat/me/availability da issue #102.

export type Availability = "online" | "busy" | "offline" | "on_break";

export const MY_AVAILABILITY_EVENT = "gk:chat:my-availability";

const VALID: readonly string[] = ["online", "busy", "offline", "on_break"];

// O mapa `users` do payload e chaveado por chatwootAgentId (id do CW), nao pelo
// id da Platform — por isso guardamos o id resolvido (via snapshot do mount).
let myChatwootAgentId: number | null = null;

export function setMyChatwootAgentId(id: number | null): void {
  myChatwootAgentId = id ?? null;
}

/**
 * Id do PROPRIO agente no motor de chat, ou null quando ainda nao resolveu
 * (boot em voo, agente sem ChatAgentSync). Quem usa pra FILTRAR evento tem que
 * tratar o null como "nao sei" e deixar passar — nunca como "nao sou eu".
 */
export function getMyChatwootAgentId(): number | null {
  return myChatwootAgentId;
}

/**
 * Retorna o availability do proprio agente lido do payload `presence.update`,
 * ou null quando nao da pra derivar com seguranca: id nao resolvido (sync
 * incompleto/stale — issue #102 C4/C7), payload sem `users` (C8), eu nao estou
 * no mapa (broadcast de outro agente), ou valor invalido. Nesses casos o
 * chamador NAO deve fazer fetch — o estado inicial veio do GET do mount.
 */
export function deriveMyAvailability(presence: unknown): Availability | null {
  if (myChatwootAgentId == null) return null;
  const users = (presence as { users?: Record<string, unknown> } | null | undefined)?.users;
  if (!users || typeof users !== "object") return null;
  const raw = users[String(myChatwootAgentId)];
  return typeof raw === "string" && VALID.includes(raw) ? (raw as Availability) : null;
}

export function emitMyAvailability(availability: Availability): void {
  try {
    window.dispatchEvent(
      new CustomEvent(MY_AVAILABILITY_EVENT, { detail: { availability } }),
    );
  } catch {
    // SSR/no-window — no-op
  }
}
